import React, { useEffect, useState } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import { Button, Input } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import _ from "lodash";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import {
  useAddServiceMutation,
  useUpdateServiceMutation,
} from "../../Data/services/serviceApi";
import { Controller, useForm } from "react-hook-form";
import {
  useAddLevelMutation,
  useUpdateLevelMutation,
} from "../../Data/services/levelApi";

const EditLevelsModal = ({ handleEditModalClose, editData, refetch }) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm({});
  const [rowId, setRowId] = useState("");
  const [sending, setSending] = useState(false);

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (editData) {
      setRowId(editData.id);
      setValue("name", editData.name);
      setValue("points", editData.points);
      setValue("level", editData.level);
    }
  }, [editData, mounted]);

  const [addLevel, { isLoading: adding }] = useAddLevelMutation();
  const [updateLevel, { isLoading: updating }] = useUpdateLevelMutation();

  const handleSave = async (data) => {
    console.log(rowId);
    console.log(data);

    setSending(true);
    try {
      let response;
      if (editData) {
        response = await updateLevel({ data, id: rowId }).unwrap();
      } else {
        response = await addLevel(data).unwrap();
      }

      console.log(response);

      if (response.code === 200) {
        refetch();
        setSending(false);
        SuccessToast(response?.message);
        handleEditModalClose();
      }
    } catch (error) {
      console.log(error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
      handleEditModalClose();
      setSending(false);
    }
  };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 text-black">
              {editData ? "Edit Level" : "Add Level"}
            </p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            <Form onSubmit={handleSubmit(handleSave)}>
              <Row>
                <Col md={12}>
                  <div className="d-flex justify-content-between">
                    <p className="m-0 text-black">Name</p>
                    {errors?.name?.message ? (
                      <p className="m-0 text-danger text-center">
                        {errors?.name?.message}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <Controller
                    control={control}
                    name="name"
                    // defaultValue={""}
                    rules={{
                      required: "Name is required.",
                    }}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Input
                        classes="mt-2 mb-3"
                        type="text"
                        placeholder="Enter name"
                        value={value}
                        onChange={onChange}
                      />
                    )}
                  />
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <div className="d-flex justify-content-between">
                    <p className="m-0 text-black">Points</p>
                    {errors?.points?.message ? (
                      <p className="m-0 text-danger text-center">
                        {errors?.points?.message}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <Controller
                    control={control}
                    name="points"
                    // defaultValue={""}
                    // rules={{
                    //   required: " is required.",
                    // }}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Input
                        classes="mt-2 mb-3"
                        type="number"
                        placeholder="Enter points"
                        value={value}
                        onChange={onChange}
                      />
                    )}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className="d-flex justify-content-between">
                    <p className="m-0 text-black">Level</p>
                    {errors?.level?.message ? (
                      <p className="m-0 text-danger text-center">
                        {errors?.level?.message}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <Controller
                    control={control}
                    name="level"
                    // defaultValue={""}
                    // rules={{
                    //   required: " is required.",
                    // }}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Input
                        classes="mt-2 mb-3"
                        type="number"
                        placeholder="Enter level"
                        value={value}
                        onChange={onChange}
                      />
                    )}
                  />
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Button
                    classes={`${cssStyles.cardBtn} mt-4 `}
                    text={
                      sending ? (
                        <Spinner
                          animation="grow"
                          size="sm"
                          className="mx-3 my-1"
                        />
                      ) : editData ? (
                        "Update"
                      ) : (
                        "Save"
                      )
                    }
                    onClick={handleSubmit}
                  ></Button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default EditLevelsModal;
